import { actionTypes } from '../actions/loader.actions'

const initialState = {
  loaderVisible: false,
  loaderMessage: '',
  _loaderCount: 0,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.show: {
      const nextCount = state._loaderCount + 1

      return {
        ...state,
        _loaderCount: nextCount,
        loaderVisible: true,
        loaderMessage: action.payload || state.loaderMessage,
      }
    }

    case actionTypes.hide: {
      const nextCount = Math.max(0, state._loaderCount - 1)

      return {
        ...state,
        _loaderCount: nextCount,
        loaderVisible: nextCount > 0,
        loaderMessage: nextCount > 0 ? state.loaderMessage : '',
      }
    }

    case actionTypes.reset: {
      return initialState
    }

    default:
      return state
  }
}

export default reducer
